module.exports = __webpack_public_path__ + "img/stickers-bulletin-paie-x3.25512ddb.jpg";